import Marionette from "backbone.marionette";
import Radio from "backbone.radio";
import Authentication from "../../authentication";
import Timeout from "../../common/timeout";
import RootView from "../../views/environment-selector";

const globalChannel = Radio.channel("global");

class Application extends Marionette.Application {
  regions() {
    return {
      container: "#main-content .centered",
    };
  }

  initialize() {
    // console.group("Application");
    // console.log("initialize");
    // console.time("app-start");

    // setup listeners
    this.listenTo(globalChannel, "auth-user-set", this._onAuthUserSet);
  }

  // receives options passed to start()
  onBeforeStart(options) {
    // console.log("onBeforeStart");

    new Timeout();

    return options;
  }

  // receives options passed to start()
  onStart(options) {
    // console.log("onStart");

    new Authentication();

    return options;
  }

  _onAuthUserSet() {
    // console.log("_onAuthUserSet");

    this.container.show(new RootView());

    // console.timeEnd("app-start");
    // console.groupEnd();
  }
}

export { Application as default };
